<app-wizard-three-steps-container
	[wizard]="wizard"
	[hidden]="isOpenConditions"
></app-wizard-three-steps-container>

@if (isOpenConditions) {
	<app-individual-conditions-list
		[conditions]="getConditions()"
		(titleClick)="conditionsClickOnTitle()"
	></app-individual-conditions-list>
}
